// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.div_req_byte[data-v-536c33e2] {text-align:right; margin-top:2px;}\n/* .email_sec label+input[type=\"text\"] {margin-left:15px; margin-right:2px;}\n.form_box{height: auto;}\n#vocForm .grid.service_rdo li{margin-left: 13px;margin-right: 0px;position: relative;}\n#vocForm .grid.service_rdo li:first-child{margin-left: 0px;}\n.popup_wrap {border-radius: none !important; box-shadow: none !important;} */\n", ""]);
// Exports
module.exports = exports;
